<!--
 * @Name: 轮播图;
 * @Date: 2020-07-23 16:31:07
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 10:01:34
 * @FilePath: \car-demo\src\components\Swiper.vue
-->
<template>
  <div v-if="lists && lists.length" style="margin-bottom:8px;">
    <nut-swiper
        class="banner"
        direction="horizontal"
        :loop="true"
        :canDragging="false"
        :paginationVisible="true"
        :autoPlay="3000"
        :swiperData="lists"
        ref="banner"
    >
      <div @click="click(item)" class="nut-swiper-slide" v-for="(item, index) in lists" :key="index">
        <img :src="item.ad_code" alt="..."/>
      </div>
    </nut-swiper>
  </div>

</template>

<script>
import cache from "../utils/cache";

export default {
  name: 'banner',
  data: () => ({
    lists: [],
    dataImgItem: [],
  }),
  created() {
    this.getLists();
  },
  methods: {
    getLists() {
      let swiperBanner = cache.get('swiperBanner');
      if (swiperBanner) {
        this.lists = JSON.parse(swiperBanner);
      } else {
        this.$ajax.get('m/system/ad_banner', {
          activity_id: this.$ajax.get_activity_id(),
          pos: 10
        }).then(res => {
          this.lists = res;
          cache.set('swiperBanner', JSON.stringify(res));
        })
      }
    },
    click(item) {

      //无链接,点击直接返回
      if (item.link_type === 'no_link') return;

      if (item.link_type === 'web_app') {
        window.location.href = item.ad_link;
        return;
      }

      //app 直接跳转到内页
      if (item.link_type === 'app') {
        var host = window.location.host;
        if(item.ad_key.indexOf("maintain") != -1){
            window.location.href = 'http://'+host+'/'+item.ad_key+'/#/';
        }else if(item.ad_key.indexOf("businessList") != -1){
            window.location.href = 'http://'+host+'/maintain/#/pages/store-list/store-list?project_id=0';
        }else{
          let query = {
            activity_id: this.$ajax.get_activity_id(),
            id: item.ad_link
          };

          this.$router.push({name: item.ad_key, query: query})
        }
        
      }

    }
  },
}
</script>

<style lang="less" scoped>
.nut-swiper-slide {
  img {
    width: 100%;
    height: 100%;
  }
}

.banner {
  height: 180px;
}
</style>
